import { TimelineFooter } from './TimelineFooter';
import { TimelineGroup } from './TimelineGroup';
import { TimelineItem } from './TimelineItem';

export const Timeline = {
    Footer: TimelineFooter,
    Group: TimelineGroup,
    Item: TimelineItem,
} as const;
